import { i18n } from "@/locales";

export enum RegisterMethods {
  Email = "email",
  Phone = "phone",
}

export enum LoginMethods {
  LDAP = "ldap",
  AppQr = "app-qrcode",
  Password = "password",
  PhoneCode = "phone-code",
  WxMinQr = "wechat-miniprogram-qrcode", // 对应社会化登录的 wechat:miniprogram:qrconnect(小程序扫码登录)
  AD = "ad", // 对应企业身份源的 Windows AD 登录
}

export const LOGIN_METHODS_MAP = {
  [LoginMethods.Password]: i18n.t("login.pwdLogin"),
  [LoginMethods.PhoneCode]: i18n.t("login.verifyCodeLogin"),
  [LoginMethods.AppQr]: i18n.t("login.appScanLogin"),
  [LoginMethods.WxMinQr]: i18n.t("login.scanLogin"),
  [LoginMethods.LDAP]: i18n.t("login.ldapLogin"),
  [LoginMethods.AD]: i18n.t("login.adLogin"),
};

export const REGISTER_METHODS_MAP = {
  [RegisterMethods.Email]: i18n.t("login.emailRegister"),
  [RegisterMethods.Phone]: i18n.t("login.phoneRegister"),
};
